import axios from 'axios'
import { API_URL } from '../../config.js'

const api = axios.create({
  baseURL: API_URL || 'http://localhost:8080',
  validateStatus: () => true,
})

export default api
